import { initAutoLc } from '@/locales/ko/views/delivery_charge_dialog';
const lc = initAutoLc('table_header.');
// eslint-disable-next-line import/prefer-default-export
export const deliveryChargeTableHeader = [
    {
        title: lc('id'),
        value: 'id',
        align: 'center',
        width: 100,
    },
    // 구분
    {
        title: lc('type'),
        value: 'type',
        align: 'center',
        width: 70,
    },
    {
        title: lc('time'),
        value: 'time',
        align: 'center',
        width: 125,
    },
    // 도착지(지명)
    {
        title: lc('special_area'),
        value: 'specialArea',
        align: 'center',
        // width: 150,
    },
    // 시작KM(이상)
    {
        title: lc('distance_start'),
        value: 'distanceStart',
        align: 'center',
        width: 110,
    },
    // 도착KM(미만)
    {
        title: lc('distance_end'),
        value: 'distanceEnd',
        align: 'center',
        width: 110,
    },
    // 번지시작(이상)
    {
        title: lc('jibun_above'),
        value: 'jibunAbove',
        align: 'center',
        width: 120,
    },
    // 번지종료(이하)
    {
        title: lc('jibun_below'),
        value: 'jibunBelow',
        align: 'center',
        width: 120,
    },
    // 구역명
    {
        title: lc('area_name'),
        value: 'areaName',
        align: 'center',
        width: 150,
    },
    // 대행료
    {
        title: lc('charge'),
        value: 'charge',
        align: 'center',
        width: 100,
    },
    // 할증배달대행료
    {
        title: lc('surcharge'),
        value: 'surcharge',
        align: 'center',
        width: 120,
    },
    // 적용요일
    {
        title: lc('week'),
        value: 'week',
        align: 'center',
        width: 130,
    },
];
export const deliveryChargeTypeName = {
    // 거리
    DISTANCE: 'DISTANCE',
    // 번지
    LOT_NUMBER_ADDRESS: 'LOT_NUMBER_ADDRESS',
    // 구역
    AREA: 'AREA',
};
export const deliveryChargeTypeNameLocale = {
    DISTANCE: '거리',
    LOT_NUMBER_ADDRESS: '번지',
    AREA: '구역',
};
export const deliveryChargeTypeColor = {
    DISTANCE: 'blue',
    LOT_NUMBER_ADDRESS: 'green',
    AREA: 'red',
};
